// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setPathDatabaseHighlightedIds } from 'redux/modules/pathDatabase/actions'

const updatePathDatabaseHighlightedData = highlightedPathIds => (dispatch, getState) => {
  // save updated list to redux
  dispatch(setPathDatabaseHighlightedIds(
    highlightedPathIds,
  ))
}

export default updatePathDatabaseHighlightedData
